import { AgsOverAnimateThreshold } from "ags/state-machine/decisions/ags-over-threshold";
import { AgsHighlightWinsState } from "ags/state-machine/states/ags-highlight-wins-state";
import { AgsIsRecoveryPickState } from "ags/state-machine/states/ags-is-recovery-pick-state";
import { AgsRollUpState } from "ags/state-machine/states/ags-roll-up-state";
import { stateMachine } from "appworks/state-machine/state-machine";
import { GameiomGameOverState } from "gameiom/states/gameiom-game-over-state";
import { GameiomRecoveryState } from "gameiom/states/gameiom-recovery-state";
import { IsAutoplayDecision } from "slotworks/state-machine/standard/decisions/is-autoplay-decision";
import { IsRecoveryDecision } from "slotworks/state-machine/standard/decisions/is-recovery-decision";
import { IsWinDecision } from "slotworks/state-machine/standard/decisions/is-win-decision";
import { AutoplayState } from "slotworks/state-machine/standard/states/autoplay-state";
import { RecoverMatrixState } from "slotworks/state-machine/standard/states/recover-matrix-state";
import { RecoverSpinState } from "slotworks/state-machine/standard/states/recover-spin-state";
import { RecoverState } from "slotworks/state-machine/standard/states/recover-state";
import { ThemeInitState } from "states/theme-init-state";
import { ThemeLoopWinsState } from "states/theme-loop-wins-state";
import { ThemeSparkSpinState } from "states/theme-spark-spin-state";
import { GameiomIdleState } from "gameiom/states/gameiom-idle-state";
import { AutoplayDelayState } from "slotworks/state-machine/standard/states/autoplay-delay-state";
import { ThemeEnterFreespinsState } from "states/theme-enter-freespins-state";
import { AgsFreespinIdleState } from "ags/state-machine/states/ags-freespin-idle-state";
import { ThemeExitFreespinsState } from "states/theme-exit-freespins-state";
import { ThemeRetriggerFreespinsState}  from "states/theme-retriger-freespins-state";
import { GameiomRequestFreespinState } from "gameiom/states/gameiom-request-freespin-state";
import { AgsFreespinsTriggeredHighlightWinsState } from "ags/state-machine/states/ags-freespins-triggered-highlight-wins-state";
import { InFreespinsDecision } from "slotworks/state-machine/standard/decisions/in-freespins-decision";
import { FreespinsTriggeredDecision } from "slotworks/state-machine/standard/decisions/freespins-triggered-decision";
import { ShouldExitFreespinsDecision } from "slotworks/state-machine/standard/decisions/should-exit-freespins-decision";
import { ThemeFreespinCelebrationState } from "states/theme-freespin-celebration-state";
import { FreespinsRetriggeredDecision } from "slotworks/state-machine/standard/decisions/freespins-retriggered-decision";
import { ThemeFreespinRetriggerCelebrationState } from "states/theme-freespin-retrigger-celebration-state";
import { ThemeIsRecoveryFreespinsTriggeredDecision } from "decisions/theme-is-recovery-freespins-triggered-decision";
import { ThemeRecoverFreespinsState } from "states/theme-recover-freespins-state";
import { ThemeRecoverFreespinsTriggeredState } from "states/theme-recover-freespins-triggered-state";
import { GameiomRequestSpinState } from "gameiom/states/gameiom-request-spin-state";
import { ThemeDelayFreespinsExitState } from "states/theme-delay-freespins-exit-state";

export function ThemeStateSetup(): void {
    // Decisions
    const isRecoveryDecision = new IsRecoveryDecision();
    const isWinDecision = new IsWinDecision();
    const agsOverAnimateThreshold = new AgsOverAnimateThreshold();
    //IsAutoplayDecision
    const isAutoplayGameOverDecision = new IsAutoplayDecision();
    const isAutoplayWinCycleDecision = new IsAutoplayDecision();
    const isAutoplayDecision = new IsAutoplayDecision();
    const isAutoplayPostFreespinDecision = new IsAutoplayDecision();
    //InFreespinsDecision
    const inFreespinsDecision = new InFreespinsDecision();
    const isRecoveryInFreespinsDecision = new InFreespinsDecision();
    const winCycleActiveCheckInFreespinsDecision = new InFreespinsDecision();
    const winCycleSkipActiveCheckInFreespinsDecision = new InFreespinsDecision();
    const noWinContinueCheckInFreespinsDecision = new InFreespinsDecision();
    const highlightWinsSkipCheckInFreespinsDecision = new InFreespinsDecision();
    //FreespinsTriggeredDecision
    const freespinsTriggeredDecision = new FreespinsTriggeredDecision();
    const isFreespinsTriggeredDecision = new FreespinsTriggeredDecision();
    const highlightWinsFreespinsTriggeredDecision = new FreespinsTriggeredDecision();

    const winCycleFreespinsTriggeredDecision = new FreespinsTriggeredDecision();
    const winCycleSkipFreespinsTriggeredDecision = new FreespinsTriggeredDecision();
    const winCycleSkipAutoplayDecision = new IsAutoplayDecision();

    const shouldExitFreespinsDecision = new ShouldExitFreespinsDecision();
    const themeIsRecoveryFreespinsTriggeredDecision = new ThemeIsRecoveryFreespinsTriggeredDecision();
    const freespinsRetriggeredDecision = new FreespinsRetriggeredDecision();
    // States
    const themeInitState = new ThemeInitState();
    const gameiomRecoveryState = new GameiomRecoveryState();
    const themeSparkSpinState = new ThemeSparkSpinState({ enableSafetyCheck: false });
    const gameiomIdleState = new GameiomIdleState();
    const gameiomRequestFreespinState = new GameiomRequestFreespinState();
    const themeEnterFreespinsState = new ThemeEnterFreespinsState();
    const agsFreespinsTriggeredHighlightWinsState = new AgsFreespinsTriggeredHighlightWinsState();
    const agsFreespinIdleState = new AgsFreespinIdleState();
    const themeRetriggerFreespinsState = new ThemeRetriggerFreespinsState();
    const themeExitFreespinsState = new ThemeExitFreespinsState({ countupAmountWon: false });
    const themeFreespinCelebrationState = new ThemeFreespinCelebrationState();
    const themeFreespinRetriggerCelebrationState = new ThemeFreespinRetriggerCelebrationState();
    const recoverSpinState = new RecoverSpinState();
    const gameiomGameOverState = new GameiomGameOverState();
    const autoplayState = new AutoplayState();
    const autoplayDelayState = new AutoplayDelayState(300);
    const themeGameiomRequestSpinState = new GameiomRequestSpinState();
    const themeLoopWinsState = new ThemeLoopWinsState();
    const recoverState = new RecoverState();
    const agsHighlightWinsState = new AgsHighlightWinsState();
    const agsRollUpState = new AgsRollUpState();
    const freespinsExitDelayState = new ThemeDelayFreespinsExitState(750, 1500);
    const themeRecoverFreespinsState = new ThemeRecoverFreespinsState({ setWinningsToTotalWin: true });
    const themeRecoverFreespinsTriggeredState = new ThemeRecoverFreespinsTriggeredState();
    stateMachine.addStates([
        { state: themeInitState, links: { complete: isRecoveryDecision }, entryPoint: true },
        { state: gameiomRecoveryState, links: { complete: isRecoveryInFreespinsDecision } },
        { state: themeRecoverFreespinsState, links: { complete: themeSparkSpinState } },
        { state: gameiomIdleState, links: { skip: isAutoplayDecision, complete: isAutoplayDecision } },
        //gameiom request spin state
        { state: themeGameiomRequestSpinState, links: { complete: themeSparkSpinState, skip: themeSparkSpinState, error: gameiomIdleState }, cascadeSkip: true },
        //spin state
        { state: themeSparkSpinState, links: { complete:isFreespinsTriggeredDecision,skip:isFreespinsTriggeredDecision} },
        { state: gameiomGameOverState, links: { complete: isAutoplayGameOverDecision } },
        { state: autoplayDelayState, links: { complete: autoplayState, skip: autoplayState, error: gameiomIdleState } },
        { state: autoplayState, links: { complete: themeGameiomRequestSpinState, skip: themeGameiomRequestSpinState } },
        { state: recoverState, links: { complete: isWinDecision } },
        { state: recoverSpinState, links: { complete: themeSparkSpinState } },
        { state: themeExitFreespinsState, links: { complete: isAutoplayPostFreespinDecision } },
        { state: themeLoopWinsState, links: { complete: winCycleActiveCheckInFreespinsDecision, skip: winCycleSkipActiveCheckInFreespinsDecision } },
        { state: agsHighlightWinsState, links: { complete: agsRollUpState } },
        { state: themeEnterFreespinsState, links: { complete: agsFreespinIdleState } },
        { state: agsFreespinIdleState, links: { complete: gameiomRequestFreespinState, skip: gameiomRequestFreespinState } },
        { state: gameiomRequestFreespinState, links: { complete: themeSparkSpinState, skip: themeSparkSpinState }, cascadeSkip: true },
        { state: agsFreespinsTriggeredHighlightWinsState, links: { complete: agsFreespinIdleState } },
        { state: themeRetriggerFreespinsState, links: { complete: isWinDecision } },
        { state: themeRecoverFreespinsTriggeredState, links: { complete: freespinsTriggeredDecision } },
        { state: themeFreespinRetriggerCelebrationState, links: { complete: themeRetriggerFreespinsState } },
        { state: themeFreespinCelebrationState, links: { complete: agsRollUpState } },
        { state: freespinsExitDelayState, links: { complete: themeExitFreespinsState } },
    ]);
    stateMachine.addDecisions([
        {decision : isFreespinsTriggeredDecision ,links: {true:freespinsRetriggeredDecision , false: isWinDecision}},
        { decision: freespinsTriggeredDecision, links: { true: themeFreespinCelebrationState, false: isWinDecision } },
        { decision: inFreespinsDecision, links: { true:freespinsRetriggeredDecision , false: themeFreespinCelebrationState } },
        { decision: freespinsRetriggeredDecision, links: { true: themeFreespinRetriggerCelebrationState, false:themeFreespinCelebrationState  } },
        { decision: highlightWinsSkipCheckInFreespinsDecision, links: { true: agsRollUpState, false: highlightWinsFreespinsTriggeredDecision } },
        { decision: highlightWinsFreespinsTriggeredDecision, links: { true: agsFreespinsTriggeredHighlightWinsState, false: agsHighlightWinsState } },
        { decision: agsOverAnimateThreshold, links: { true: highlightWinsSkipCheckInFreespinsDecision, false: agsRollUpState } },
        { decision: isRecoveryDecision, links: { true: gameiomRecoveryState, false: gameiomIdleState } },
        { decision: isRecoveryInFreespinsDecision, links: { true: themeRecoverFreespinsState, false: recoverSpinState } },
        { decision: themeIsRecoveryFreespinsTriggeredDecision, links: { true: themeRecoverFreespinsTriggeredState, false: recoverSpinState } },
        { decision: isAutoplayDecision, links: { true: autoplayDelayState, false: themeGameiomRequestSpinState}},

        { decision: isWinDecision, links: { true: agsOverAnimateThreshold, false: noWinContinueCheckInFreespinsDecision } },

        { decision: noWinContinueCheckInFreespinsDecision, links: { true: shouldExitFreespinsDecision, false: gameiomGameOverState } },
        { decision: isAutoplayPostFreespinDecision, links: { true: autoplayDelayState, false: gameiomIdleState } },
        { decision: isAutoplayGameOverDecision, links: { true: autoplayDelayState, false: gameiomIdleState } },
        { decision: shouldExitFreespinsDecision, links: { true: freespinsExitDelayState, false: agsFreespinIdleState } },

        { decision: winCycleActiveCheckInFreespinsDecision, links: { true: "exit-3", false: winCycleFreespinsTriggeredDecision } },
        { decision: winCycleSkipActiveCheckInFreespinsDecision, links: { true: "exit-3", false: winCycleSkipFreespinsTriggeredDecision } },
        { decision: winCycleFreespinsTriggeredDecision, links: { true: "exit-4", false: isAutoplayWinCycleDecision } },
        { decision: winCycleSkipFreespinsTriggeredDecision, links: { true: "exit-4", false: winCycleSkipAutoplayDecision } },
        { decision: winCycleSkipAutoplayDecision, links: { true: "exit-2", false: "exit-1" } },
        { decision: isAutoplayWinCycleDecision, links: { true: "exit-2", false: themeLoopWinsState } }
    ]);

    stateMachine.addSuperStates([
        {
            superState: agsRollUpState,
            entrySubState: themeLoopWinsState,
            links: {
                "exit-1": themeGameiomRequestSpinState,
                "exit-2": autoplayDelayState,
                "exit-3": shouldExitFreespinsDecision,
                "exit-4": themeEnterFreespinsState,
                "collapse": gameiomIdleState
            }
        }
    ]);
}
